import { makeAutoObservable } from "mobx";

export type ViewContext = "site" | "tenant" | "security";

enum LocalStorageKeys {
  ORGANIZATION_ID = "userOrganizationId",
  SITE_ID = "siteToken",
  SITE_TZ = "siteTimeZone",
  VIEW_CONTEXT = "viewContext",
  MEILISEARCH_TOKEN = "meilisearchToken",
}

class UserStore {
  constructor() {
    makeAutoObservable(this);
  }

  userOrganizationId: string | null =
    localStorage.getItem(LocalStorageKeys.ORGANIZATION_ID) ?? null;

  isChangingOrganization: boolean = false;

  isLoadingViewContextAccess: boolean = true;

  siteToken: string | null = localStorage.getItem(LocalStorageKeys.SITE_ID) ?? null;

  siteTimeZone: string | null = localStorage.getItem(LocalStorageKeys.SITE_TZ) ?? null;

  viewContext: ViewContext =
    (localStorage.getItem(LocalStorageKeys.VIEW_CONTEXT) as ViewContext) ?? "site";

  meilisearchToken: string | null =
    localStorage.getItem(LocalStorageKeys.MEILISEARCH_TOKEN) ?? null;

  setUserOrganizationId = (userOrganizationId: string) => {
    this.userOrganizationId = userOrganizationId;

    localStorage.setItem(LocalStorageKeys.ORGANIZATION_ID, userOrganizationId);
  };

  setIsChangingOrganization = (isChanging: boolean) => {
    this.isChangingOrganization = isChanging;
  };

  setIsLoadingViewContextAccess = (isChanging: boolean) => {
    this.isLoadingViewContextAccess = isChanging;
  };

  clearUserOrganizationId = () => {
    this.userOrganizationId = null;

    localStorage.removeItem(LocalStorageKeys.ORGANIZATION_ID);
  };

  setSiteToken = (siteToken: string) => {
    this.siteToken = siteToken;

    localStorage.setItem(LocalStorageKeys.SITE_ID, siteToken);
  };

  setMeilisearchToken = (token: string) => {
    this.meilisearchToken = token;

    localStorage.setItem(LocalStorageKeys.MEILISEARCH_TOKEN, token);
  };

  clearSiteToken = () => {
    this.siteToken = null;

    localStorage.removeItem(LocalStorageKeys.SITE_ID);
  };

  setViewContext = (context: ViewContext) => {
    this.viewContext = context;

    localStorage.setItem(LocalStorageKeys.VIEW_CONTEXT, context);
  };

  clearViewContext = () => {
    localStorage.removeItem(LocalStorageKeys.VIEW_CONTEXT);
  };

  setSiteTimeZone = (siteTimeZone: string) => {
    this.siteTimeZone = siteTimeZone;

    localStorage.setItem(LocalStorageKeys.SITE_TZ, siteTimeZone);
  };

  clearSiteTimeZone = () => {
    localStorage.removeItem(LocalStorageKeys.SITE_TZ);
  };

  clearMeilisearchToken = () => {
    localStorage.removeItem(LocalStorageKeys.MEILISEARCH_TOKEN);
  };
}

export default UserStore;
